import {
  ExtraFieldsFormId,
  ExtraFieldsFormIds,
} from '../../../../components/ExtraFields/types';
import { EmployeeType } from './types';

// Time entries have no manager-only screen: TimeEntryManagerSmart renders both for a
// manager and for an employee with canChangeOwnTimeEntries editing their own entries.
// So manager-only fields key off employeeType, and the base `Edit` form id is kept
// alongside `ManagerDetails` so fields configured for the employee stay visible too.
export const getExtraFieldsFormIds = (
  employeeType: EmployeeType,
  isApproveMode: boolean,
): ExtraFieldsFormIds => {
  const [editFormId, managerFormId] = isApproveMode
    ? [
        ExtraFieldsFormId.TimeEntryChangeRequestEdit,
        ExtraFieldsFormId.TimeEntryChangeRequestManagerDetails,
      ]
    : [
        ExtraFieldsFormId.TimeEntryEdit,
        ExtraFieldsFormId.TimeEntryManagerDetails,
      ];
  return employeeType === 'manager'
    ? [editFormId, managerFormId]
    : [editFormId];
};
